import { render, staticRenderFns } from "./CustomSearch.vue?vue&type=template&id=5f5b6611&"
import script from "./CustomSearch.vue?vue&type=script&lang=js&"
export * from "./CustomSearch.vue?vue&type=script&lang=js&"
import style0 from "./CustomSearch.vue?vue&type=style&index=0&id=5f5b6611&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports